const INIT_STATE = {
    title: null,
    short_description: null,
    domain_type: "company_name",
    font: "default",
    product_theme: "darkmode",
    accent_theme: "#ffffff",
    lead_theme: true
}
const campaignDetailsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'SET_CAMPAIGN_DETAILS':
            return action.payload
        case 'RESET_CAMPAIGN_DETAILS':
            return INIT_STATE
        default:
            return state
    }
}
export default campaignDetailsReducer